<template>
  <div class="main-body">
    <div class="header">商品列表</div>
    <div class="out">
      <div class="search2">

        <div style="float: right;">

          <el-select v-model="businessCode" placeholder="请选择商家" style="margin-right:10px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.businessName"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>

          <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border ref="goodsTable">
            <el-table-column prop="name" fixed='left' label="标题" min-width="200"></el-table-column>
            <el-table-column label="价格">
              <template slot-scope="scope">
                <el-button type="primary" plain size="mini" @click="handlePrice(scope.row)">查看</el-button>
              </template>
            </el-table-column>

            <el-table-column prop="stock" label="库存"></el-table-column>

            <el-table-column prop="goodsClassGovernmentName" label="分类"></el-table-column>

            <el-table-column prop="goodsType" :formatter="goodsTypeValue" label="类型"></el-table-column>

            <el-table-column label="轮播图" width="100">
              <template slot-scope="scope">
                <el-button type="success" plain size="mini" @click="handlecarousel(scope.row)">查看</el-button>
              </template>
            </el-table-column>
            <el-table-column label="推荐">
              <template slot-scope="scope">
                <el-tag v-show="scope.row.isRecommend==0" type="danger">否</el-tag>
                <el-tag v-show="scope.row.isRecommend==1">是</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="特价">
              <template slot-scope="scope">
                <el-tag v-show="scope.row.isBargainPrice==0" type="danger">否</el-tag>
                <el-tag v-show="scope.row.isBargainPrice==1">是</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="下架">
              <template slot-scope="scope">
                <el-tag v-show="scope.row.status==0" type="danger">否</el-tag>
                <el-tag v-show="scope.row.status==1" type="danger">否</el-tag>
                <el-tag v-show="scope.row.status==2">是</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
          </el-table>

          <div class="page">
            <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination small
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


    </div>

    <el-dialog
        title="轮播图"
        :visible.sync="showModalCarousel"
        center
        top='30vh'
        width="600px" :close-on-click-modal='false'>
      <template>
        <el-carousel indicator-position="outside">
          <el-carousel-item v-for="item in carouselValue" :key="item">
            <el-image :src="imgUrl+item" fit='contain' style="width:100%;height:100%">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </el-carousel-item>
        </el-carousel>
      </template>
    </el-dialog>
    <el-dialog
        title="商品价格/库存"
        :visible.sync="showModalPrice"
        center
        top='30vh'
        width="600px" :close-on-click-modal='false'>
      <template>
        <el-table
            :data="goodsPriceDTOList"
            :span-method="arraySpanMethods"
            border
            height="350"
            v-if="goodsPriceDTOList.length>0"
            style="width: 100%">
          <el-table-column
              v-if="goodsPriceDTOList[0].goodsColorName"
              prop="goodsColorName"
              label="颜色">
          </el-table-column>
          <el-table-column
              v-if="goodsPriceDTOList[0].goodsSizeName"
              prop="goodsSizeName"
              label="尺寸">
          </el-table-column>
          <el-table-column
              prop="price"
              label="单价（元）">
          </el-table-column>
          <el-table-column
              prop="stock"
              label="库存">
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      tableLoading: false,
      loading:false,
      showModalAdd:false,
      showModalCarousel:false,
      options:{
        value:'goodsClassCode',
        label:'name',
        children:'goodsClassGovernmentList',
        emitPath:false
      },
      showModalPrice:false,
      showModalEdit:false,
      showModalAddClass:false,
      tableData:null,
      goodsClassCode:'',
      column:'',
      carouselValue:[],
      goodsPriceDTOList:[],
      imgUrl:this.$imgUrl,


      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      status:-1,
      status2: [{
        value: -1,
        label: '全部状态'
      },{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '下架'
      }],

      goodsClassValue:[],
      goodsClassGovValue:[],
      goodsClassBusinessValue:[],
      addGoodsClassCode:'',

      searchData:[],
      searchForm:{
        name: '',
        isRecommend: -1,
        isDelete:-1,
        isBargainPrice:-1,
        goodsClassGovernmentCode:''
      },

      arr_business:[],
      businessCode:'',


    }
  },
  components:{

  },
  created(){
    this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    init:function(){

      this.getBusiness();



    },

    handlecarousel(row){
      this.carouselValue=[]
      for(var i=0;i<4;i++){
        if(row['head'+(i+1)]){
          this.carouselValue.push(row['head'+(i+1)])
        }
      }
      this.showModalCarousel=true
    },
    handlePrice(row){
      this.goodsPriceDTOList=row.goodsPriceDTOList
      this.goodsPriceDTOList.sort(this.compare('goodsColorName'))
      this.showModalPrice=true
    },
    arraySpanMethods({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if(rowIndex ===0 || row.goodsColorName != this.goodsPriceDTOList[rowIndex-1].goodsColorName){
          let rowspan = 0;
          this.goodsPriceDTOList.forEach(element => {
            if(element.goodsColorName === row.goodsColorName){
              rowspan ++;
            }
          });
          return [rowspan, 1];
        }else {
          return [0, 0];
        }
      }
      this.column=column
    },
    compare(property) {
      return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1.localeCompare(value2);
      }
    },
    goodsTypeValue(row){
      if(row.goodsType==1){
        return '普通类'
      }else if(row.goodsType==2){
        return '服务类'
      }else{
        return '其它'
      }
    },
    confirmClass(){
      this.showModalAddClass = false;
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.addGoodsClassCode);
    },
    //日期格式
    timefilter(row){
      return timefilters(row.createTime)
    },
    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd:function(){
      this.showModalAddClass = false;
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.addGoodsClassCode);
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },


    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {

              this.arr_business = response.data.data;
              if(this.arr_business.length>0){

                this.businessCode = this.arr_business[0].businessCode;
                this.getList(false);
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },


    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true
      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        businessCode:this.businessCode,
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/PageForGov",
        data: data
      }).then( (response)=> {
        _this.tableLoading=false
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.$nextTick(()=>{
            this.$refs.goodsTable.doLayout()
          })
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },
    statusTitle(row){
      if(row.isDelete == 1){
        return "否";
      }
      if(row.isDelete == 2){
        return "是";
      }
      return "其它";
    },
    goodsTypeTitle(row){
      if(row.goodsType == 1){
        return "普通商品";
      }
      if(row.goodsType == 2){
        return "社会化服务";
      }
      if(row.goodsType == 3){
        return "政府购买服务";
      }
      return "其它";
    },
    auditStatusTitle(row){
      if(row.auditStatus == 0){
        return "待审核";
      }
      if(row.auditStatus == 1){
        return "审核通过";
      }
      if(row.auditStatus == 2){
        return "被驳回";
      }
      return "其它";
    }



  }
}
</script>

<style scoped>

</style>
